module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_17.7a216e02.webp";